import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-forward', 'ArrowForward', [["path",{"d":"M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"}]]);